import { Component, Input, OnInit } from '@angular/core';
import { UserContext } from '@core/models';
import { WellKnownRoutes } from 'app/core/enums/well-known-routes';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

enum Label {
  Dashboard = 'Dashboard',
  Paystubs = 'Paystubs',
  TaxForms = 'Tax Forms',
  Profile = 'Profile',
}

enum Icon {
  Dashboard = 'fa-home-alt',
  Paystubs = 'fa-money-check-dollar',
  TaxForms = 'fa-file-invoice-dollar',
  Profile = 'fa-user',
}

interface navRoutes {
  label: Label;
  route: WellKnownRoutes;
  icon: Icon;
}

const navRoutes: navRoutes[] = [
  {
    label: Label.Dashboard,
    route: WellKnownRoutes.Dashboard,
    icon: Icon.Dashboard,
  },
  {
    label: Label.Paystubs,
    route: WellKnownRoutes.Paystubs,
    icon: Icon.Paystubs,
  },
  {
    label: Label.TaxForms,
    route: WellKnownRoutes.TaxForms,
    icon: Icon.TaxForms,
  },
  {
    label: Label.Profile,
    route: WellKnownRoutes.Profile,
    icon: Icon.Profile,
  },
];

@Component({
  selector: 'sp-nav',
  template: `
    <nav class="navbar" [ngClass]="{ sp: isSure }">
      <ul class="nav-menu">
        <li class="nav-item" *ngFor="let link of navLinks">
          <a
            #navElements
            class="nav-link"
            routerLink="{{ link.route }}"
            [routerLinkActive]="'active'"
            #activeLink="routerLinkActive">
            <div class="nav-link-container">
              <div class="nav-icon">
                <i
                  class="fa-2x"
                  [class]="link.icon"
                  [ngClass]="activeLink.isActive ? 'fa-solid' : 'fal'"></i>
              </div>
              <div class="link-label">
                <p>{{ link.label }}</p>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </nav>
  `,
  styleUrls: ['top-nav.component.scss'],
})
export class NavComponent implements OnInit {
  navLinks = navRoutes;
  isActive = false;
  isSure = true;
  @Input() userContext: UserContext;

  ngOnInit(): void {
    const programCode = this.userContext.programCode;
    this.isSure = ProgramCodeConstants.isSureClient(programCode);
  }
}
